import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { FloatButton } from "antd";
import { Header, Footer, Backdrop } from "../index";
import { useEffectDeviceAndOrientation } from "utils/hooks";
import "react-toastify/dist/ReactToastify.css";
import "./Dashboard.scss";
import Breadcrumbs from "components/breadcrumb/Breadcrumbs";
import { FaViber } from "react-icons/fa6";
import { RootState } from "store";
import { useSelector } from "react-redux";

const Dashboard = () => {
  const { pathname } = useLocation();
  const [device, orientation] = useEffectDeviceAndOrientation();
  const theme = useSelector((state: RootState) => state.theme);
  const [isArticlePage, setIsArticlePage] = useState(false);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    let script: any;
    if (!window.location.pathname.includes("/article/")) {
      script = document.createElement("script");
      script.textContent = `
      if(window.shoply){
        window.shoply.showMiniChat(null);
      }
      `;
      document.body.appendChild(script);
      setIsArticlePage(false);

      const buttonShoply: any = document.querySelector(
        ".__shoply__mini-chat-open-button"
      );
      const containerShoply: any = document.querySelector(
        ".__shoply__mini-chat-container"
      );
      const headerShoply: any = document.querySelector(
        ".__shoply__mini-chat-menu-header"
      );

      if (buttonShoply) {
        buttonShoply.style.width = "40px";
        buttonShoply.style.height = "40px";
        const svg = buttonShoply?.querySelector("svg");
        if (svg) {
          svg.style.width = "50%";
          svg.style.height = "50%";
        }
      }
      if (containerShoply) {
        containerShoply.style.bottom = "49px";
        containerShoply.style.right = "24px";
      }
      if (headerShoply) {
        headerShoply.style.width = "none";
        headerShoply.style.minWidth = "none";
      }
    } else {
      setIsArticlePage(true);
    }
    return () => {
      if (script) {
        document.body.removeChild(script);
      }
    };
  }, [pathname]);

  return (
    <div>
      <div className="App">
        <Header />

        {device === "mobile" ||
        (device === "computer" && orientation === "portrait") ? (
          <Backdrop />
        ) : (
          <></>
        )}

        <div className="Content">
          <Breadcrumbs />
          <Outlet />
        </div>

        <Footer />

        <ToastContainer
          position={toast.POSITION.BOTTOM_RIGHT}
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          // pauseOnHover -> PAUZIRA PRI KRAJU
          theme={theme === "light" ? "light" : "dark"}
          className={
            device === "mobile" ? "Generic-Toast-Mobile" : "Generic-Toast"
          }
        />
        <FloatButton
          type="primary"
          style={{ insetInlineEnd: isArticlePage ? 74 : 24 }}
          className="Float-Button-1"
          tooltip={<div>Kliknite za Viber Chat</div>}
          href="viber://chat?number=%2B38766894882"
          icon={<FaViber />}
        />
        <FloatButton.BackTop
          type="default"
          style={{ insetInlineEnd: isArticlePage ? 124 : 74 }}
          className="Float-Button-2"
          tooltip={<div>Vrati se na početak</div>}
        />
      </div>
    </div>
  );
};

export default Dashboard;
